import React, { useEffect, useState } from "react";
import { pdfjs } from "react-pdf";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { useDropzone } from "react-dropzone";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { Card, Tooltip, Typography } from "@mui/material";
import PreviewAndSign from "../../../components/PreviewAndSign";
import { useMessage } from "../../../components/Header";
import { setCookie } from "../../../utilities/cookies";
import axios from "axios";
import googleDrive from "../../../style/googleDrive.svg";
import dropBox from "../../../style/dropBox.svg";
import oneDrive from "../../../style/oneDrive.svg";
import box from "../../../style/box.svg";
import uploadMainIcon from "../../../style/bytesize_upload.svg";
import Button from "@mui/material/Button";
import { env } from "../../../utilities/function";
import { useGoogleLogin } from "@react-oauth/google";
import { useLocation, useNavigate } from "react-router-dom";
import BoxIntegration from "./BoxIntegration";
import { useTheme } from "../../../style/theme.js";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "background.paper",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  border: `1px solid ${theme.mode === "dark" ? "#292929" : "#D6D6D6"}`,
  color: theme.palette.text.secondary,
}));

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  header: {
    marginBottom: theme.spacing(2),
  },
  viewer: {
    width: "100%",
    height: "calc(100vh - 120px)",
    maxWidth: "fit-content",
  },
  controls: {
    margin: theme.spacing(2, 0),
  },
  button: {
    margin: theme.spacing(1),
  },
  dropzone: {
    width: "100%",
    padding: "20px",
    height: "100%",
    textAlign: "center",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "#141414",
    boxShadow: "none",
  },
  dropzoneActive: {
    border: "1px dashed #007bff",
  },
  div1: {
    width: "350px",
    height: "70px",
    padding: "10px",
    border: `1px solid ${theme.mode === "dark" ? "#292929" : "#D6D6D6"}`,
  },
  page: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
}));

const PreviewPDF = () => {
  const classes = useStyles();
  const [scale, setScale] = useState(1);
  const [pdfFile, setPdfFile] = useState(null);
  const { showError, showSuccess } = useMessage();
  const [authToken, setAuthToken] = useState(undefined);
  const [dropBoxAuthToken, setDropBoxAuthToken] = useState(
    sessionStorage.getItem("dropBoxAuthToken")
  );
  const [boxAuthToken, setBoxAuthToken] = useState(undefined);
  const [boxPickerOpen, setBoxPickerOpen] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get("code");
  const state = queryParams.get("state");

  const navigate = useNavigate();

  const onLoadOneDriveFilePicker = async (files) => {
    // setMicrosoftAuthToken(files.accessToken);
    const dataObject = { id: files.value[0].id, authToken: files.accessToken };
    try {
      const response = await axios.post(
        env("BACKEND_SERVER") + "/document/get-one-drive-file",
        dataObject,
        {
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], { type: "application/pdf" });
      handleFileChange(blob);
      // window.push(linkurl);
    } catch (error) {
      // console.log("error", error);
    }
  };
  const authCodeFunction = async () => {
    try {
      const response = await axios.post(
        env("BACKEND_SERVER") + "/document/getAuthCodeDropBox",
        {
          code,
          clientId: env("DROPBOX_API_KEY"),
          client_secret: env("DROPBOX_CLIENT_SECRET"),
          redirect_url: env("DROPBOX_REDIRECT_URL"),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: false,
        }
      );
      if (response.status === 200) {
        // console.log(response.data);

        showSuccess("Dropbox Imported Successfully");
        setDropBoxAuthToken(response.data.accessToken);
        sessionStorage.setItem("dropBoxAuthToken", response.data.accessToken);
        navigate("/");
      } else {
        showError("Dropbox import failed.");
      }
    } catch (error) {
      showError("Dropbox import failed.");
    }
  };
  const onBoxFileSelectHandller = async (files) => {
    const { authenticated_download_url, name } = files[0];
    const response = await axios.post(
      env("BACKEND_SERVER") + "/document/get-box-file",
      { authenticated_download_url, name, accessToken: boxAuthToken },
      {
        responseType: "blob",
      }
    );
    const blob = new Blob([response.data], { type: "application/pdf" });
    handleFileChange(blob);
    setBoxPickerOpen(false);
  };
  const handleCancelFile = () => {
    setBoxPickerOpen(false);
  };
  const authCodeBoxFunction = async () => {
    try {
      const response = await axios.post(
        env("BACKEND_SERVER") + "/document/getAuthCodeBox",
        {
          code,
          clientId: env("BOX_CLIENT_ID"),
          client_secret: env("BOX_CLIENT_SECRET"),
          redirect_url: env("BOX_REDIRECT_URL"),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: false,
        }
      );
      if (response.status === 200) {
        // console.log(state, "state");

        // console.log("response.data");
        // console.log(response.data);

        showSuccess("BOX Imported Successfully");
        setBoxAuthToken(response.data.accessToken);
        navigate("/");
      } else {
        showError("BOX import failed.");
      }
    } catch (error) {
      showError("BOX import failed.");
    }
  };
  // console.log("boxcode", boxAuthToken);
  useEffect(() => {
    // this is for box
    if (state === "2020135264589015" && code) {
      authCodeBoxFunction();
    } //this is for dropbox
    else if (code) {
      authCodeFunction();
    }
  }, [code, state]);

  const openOneDrivePicker = () => {
    // Configure the file picker
    var odOptions = {
      clientId: env("MICROSOFT_CLIENT_ID"),
      action: "share",
      multiSelect: false,
      advanced: {
        // Add any advanced options here
      },
      success: onLoadOneDriveFilePicker,
      cancel: function () {
        // Handle the cancellation here
        // console.log("OneDrive picker canceled.");
      },
      error: function (e) {
        // console.log(e);
      },
    };
    // Open the file picker
    window.OneDrive.open(odOptions);
  };

  const dropBoxAuthHandller = () => {
    const authUrl = `https://www.dropbox.com/oauth2/authorize?response_type=code&client_id=${env(
      `DROPBOX_API_KEY`
    )}&redirect_uri=${env(`DROPBOX_REDIRECT_URL`)}`;
    window.location.href = authUrl;
  };

  const boxAuthHandller = () => {
    const authorizationUrl = `https://account.box.com/api/oauth2/authorize?response_type=code&client_id=${env(
      "BOX_CLIENT_ID"
    )}&redirect_uri=${env("BOX_REDIRECT_URL")}&state=2020135264589015`;

    window.location.href = authorizationUrl;
  };

  const boxPickerOpenAndClose = () => {
    setBoxPickerOpen(true);
  };

  const dropBoxChooseFileHandller = async (files) => {
    const { id, name } = files[0];
    const response = await axios.post(
      env("BACKEND_SERVER") + "/document/get-dropbox-file",
      { accessToken: dropBoxAuthToken, id, name },
      {
        responseType: "blob",
      }
    );
    const blob = new Blob([response.data], { type: "application/pdf" });
    handleFileChange(blob);
  };

  const theme = useTheme();

  const handleFileChange = async (file) => {
    setPdfFile(file);
    try {
      // const accessToken = getCookie("accessToken");
      // Create a FormData object to send the file
      const formData = new FormData();
      formData.append("document", file);
      formData.append("userId", JSON.parse(localStorage.getItem("user"))._id);
      // Make a POST request to your API endpoint
      const response = await (
        await axios.post(env("BACKEND_SERVER") + "/document/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      ).data;

      if (response?.success === true) {
        let data = {
          fileId: response.files._id,
        };
        const responseAddDocument = await axios.post(
          env("BACKEND_SERVER") + "/document/addDocument",
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
            withCredentials: false,
          }
        );

        if (responseAddDocument.data.status === 200) {
          setCookie("documentId", responseAddDocument.data.data.fileId);
          showSuccess("File is uploaded successfully!");
        }
      } else {
        showError("Error uploading file");
      }
    } catch (error) {
      showError("Error uploading file");
    }
    setScale(Math.max(scale - 0.6, 0.6));
  };

  const handleDropboxClick = () => {
    if (!window.Dropbox) {
      // console.error("Dropbox SDK not loaded");
      return;
    }
    window.Dropbox.choose({
      // direct link so we can fetch the file ourselves
      linkType: "direct",
      multiselect: false,
      extensions: [".pdf"],
      success: async (files) => {
        const { link, name } = files[0];
        // fetch the PDF blob
        const response = await axios.get(link, { responseType: "blob" });
        const blob = new Blob([response.data], { type: "application/pdf" });
        handleFileChange(blob);
      },
      cancel: () => console.log("Dropbox import canceled"),
    });
  };

  const selectGoogleDriveFileHandller = async (data) => {
    if (data.action === "cancel") {
      // console.log("User clicked cancel/close button");
    }
    if (data.action === "picked") {
      let googleDriveData = data.docs[0];
      const { id } = googleDriveData;
      const dataObject = { id, authToken };
      try {
        const response = await axios.post(
          env("BACKEND_SERVER") + "/document/get-google-drive-file",
          dataObject,
          {
            responseType: "blob",
          }
        );
        const blob = new Blob([response.data], { type: "application/pdf" });
        handleFileChange(blob);
        // window.push(linkurl);
      } catch (error) {
        // console.log("error", error);
      }
    }
  };

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => setAuthToken(tokenResponse.access_token),
    scope: ["https://www.googleapis.com/auth/drive.readonly"],
  });

  useEffect(() => {
    if (authToken) {
      showSuccess("Google Drive Imported Successfully !");
    }
  }, [authToken]);

  const handleOpenPicker = () => {
    // console.log(env("GOOGLE_API_KEY"));
    new window.google.picker.PickerBuilder()
      .addView(window.google.picker.ViewId.DOCS)
      .setOAuthToken(authToken)
      .setDeveloperKey(env("GOOGLE_API_KEY"))
      .setCallback(selectGoogleDriveFileHandller)
      .build()
      .setVisible(true);
  };

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      handleFileChange(acceptedFiles[0]);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".pdf",
  });
  const onCloseModalHandller = () => {
    setPdfFile(null);
  };

  return (
    <div
      className={classes.root}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        display="flex"
      >
        {pdfFile && (
          <Grid item xs={12} sm={12}>
            <PreviewAndSign
              handleCloseFunc={onCloseModalHandller}
              pdfFile={pdfFile}
            ></PreviewAndSign>
          </Grid>
        )}
        <Grid
          container
          spacing={2}
          display={"flex"}
          alignItems="center"
          justifyContent="space-evenly"
          className="flex justify-center items-center"
          // style={{ marginTop: "10px" }}
        >
          <Grid item xs={12} sm={6} className="m-5">
            <Typography
              variant="p"
              style={{
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "60px",
              }}
            >
              File Uploader
            </Typography>
            <Tooltip title="Drop  Or Upload Files here" arrow placement="left">
              <Card
                style={{
                  backgroundColor: theme.mode === "dark" ? "#141414" : "#fff",
                  border: `1px dashed ${
                    theme.mode === "dark" ? "#292929" : "#D6D6D6"
                  }`,
                }}
                {...getRootProps({
                  className: `${classes.dropzone} ${
                    isDragActive ? classes.dropzoneActive : ""
                  }`,
                })}
              >
                <input {...getInputProps()} />
                {isDragActive ? (
                  <p>Drop files here...</p>
                ) : (
                  <>
                    <div
                      style={{
                        backgroundColor:
                          theme.mode === "dark" ? "#171717" : "#F5F5F5",
                        width: "70px",
                        height: "70px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "5px",
                      }}
                    >
                      <img
                        src={uploadMainIcon}
                        alt="upload-main-icon"
                        className="upload-main-icon"
                      />
                    </div>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        marginTop: "20px",
                        marginBottom: "10px",
                      }}
                    >
                      Drag and drop file here to upload
                    </p>
                    <p
                      style={{
                        color: "#8698a5",
                        fontSize: "14px",
                        fontWeight: "500",
                        marginBottom: "20px",
                      }}
                    >
                      Or
                    </p>
                    <Button
                      variant="outlined"
                      style={{
                        "border-radius": "10px",
                        width: "220px",
                        padding: "10px",
                      }}
                    >
                      Upload File
                    </Button>
                  </>
                )}
              </Card>
            </Tooltip>
          </Grid>

          <Grid item xs={12} sm={4} className="p-0 items-center sm:m-8">
            <Typography
              variant="p"
              style={{
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "60px",
              }}
            >
              Import files from:
            </Typography>
            <Grid container spacing={{ xs: 1, sm: 2 }}>
              <Grid item xs={6}>
                <Tooltip
                  title="Import file from Google Drive"
                  arrow
                  placement="top"
                >
                  <Card
                    onClick={() => (authToken ? handleOpenPicker() : login())}
                    style={{ boxShadow: "none" }}
                    className={`flex items-center justify-center flex-col 
                    p-2 sm:p-3 
                    border-[${theme.mode === "dark" ? "#292929" : "#D6D6D6"}] 
                    shadow-none border`}
                  >
                    <img
                      className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
                      src={googleDrive}
                      alt="googleDrive Logo"
                    />
                    <br />
                    <Typography
                      variant="p"
                      className="text-[10px] sm:text-[12px] font-medium"
                    >
                      Google Drive
                    </Typography>
                  </Card>
                </Tooltip>
              </Grid>

              <Grid item xs={6}>
                <Tooltip
                  title="Import file from One Drive"
                  arrow
                  placement="top"
                >
                  <Card
                    onClick={openOneDrivePicker}
                    style={{ boxShadow: "none" }}
                    className={`flex items-center justify-center flex-col 
          p-2 sm:p-3 
          border-[${theme.mode === "dark" ? "#292929" : "#D6D6D6"}] 
          shadow-none border`}
                  >
                    <img
                      src={oneDrive}
                      className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
                      alt="oneDrive Logo"
                    />
                    <br />
                    <Typography
                      variant="p"
                      className="text-[10px] sm:text-[12px] font-medium"
                    >
                      One Drive
                    </Typography>
                  </Card>
                </Tooltip>
              </Grid>

              <Grid item xs={6}>
                {dropBoxAuthToken ? (
                  <Tooltip title="Import file from Dropbox" arrow>
                    <Tooltip title="Import file from Dropbox" arrow>
                      <Card
                        onClick={handleDropboxClick}
                        style={{ boxShadow: "none" }}
                        className={`flex items-center justify-center flex-col 
            p-2 sm:p-3 
            border-[${theme.mode === "dark" ? "#292929" : "#D6D6D6"}] 
            shadow-none border`}
                      >
                        <img
                          className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
                          src={dropBox}
                          alt="dropBox Logo"
                        />
                        <br />
                        <Typography
                          variant="p"
                          className="text-[10px] sm:text-[12px] font-medium"
                        >
                          Dropbox
                        </Typography>
                      </Card>
                    </Tooltip>
                  </Tooltip>
                ) : (
                  <Tooltip title="Import file from Dropbox" arrow>
                    <Card
                      onClick={dropBoxAuthHandller}
                      style={{ boxShadow: "none" }}
                      className={`flex items-center justify-center flex-col 
            p-2 sm:p-3 
            border-[${theme.mode === "dark" ? "#292929" : "#D6D6D6"}] 
            shadow-none border`}
                    >
                      <img
                        className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
                        src={dropBox}
                        alt="dropBox Logo"
                      />
                      <br />
                      <Typography
                        variant="p"
                        className="text-[10px] sm:text-[12px] font-medium"
                      >
                        Dropbox
                      </Typography>
                    </Card>
                  </Tooltip>
                )}
              </Grid>

              <Grid item xs={6}>
                {boxAuthToken ? (
                  <Card
                    onClick={boxPickerOpenAndClose}
                    style={{ boxShadow: "none" }}
                    className={`flex items-center justify-center flex-col 
          p-2 sm:p-3 
          border-[${theme.mode === "dark" ? "#292929" : "#D6D6D6"}] 
          shadow-none border`}
                  >
                    <img
                      className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
                      src={box}
                      alt="box Logo"
                    />
                    <br />
                    <Typography
                      variant="p"
                      className="text-[10px] sm:text-[12px] font-medium"
                    >
                      Box
                    </Typography>
                  </Card>
                ) : (
                  <Tooltip title="Import file from Box" arrow>
                    <Card
                      onClick={boxAuthHandller}
                      style={{
                        boxShadow: "none",
                        backgroundColor:
                          theme.mode === "dark" ? "#141414" : "#fff",
                      }}
                      className={`flex items-center justify-center flex-col 
            p-2 sm:p-3 
            border-[${theme.mode === "dark" ? "#292929" : "#D6D6D6"}] 
            shadow-none border`}
                    >
                      <img
                        className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
                        src={box}
                        alt="box Logo"
                      />
                      <br />
                      <Typography
                        variant="p"
                        className="text-[10px] sm:text-[12px] font-medium"
                      >
                        Box
                      </Typography>
                    </Card>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {boxPickerOpen && (
        <BoxIntegration
          boxaccessToken={boxAuthToken}
          handleCancelFile={handleCancelFile}
          onFileSelect={onBoxFileSelectHandller}
        />
      )}
    </div>
  );
};

export default PreviewPDF;
